<div class="toolkit__libraryGrid" *ngIf="vm.surveyItems?.length">
	<div class="toolkit__libraryCard" *ngFor="let item of vm.surveyItems">
		<div class="toolkit__libraryTitle">{{ vm.assessmentLabel(item) || ('Toolkit.Common.Untitled' | translate) }}</div>
		<div class="toolkit__libraryMeta">{{ truncateDescription(item.description || item.type || '') }}</div>
        <div class="assessment-stats">
            <span>{{ vm.themeIcon(item.theme || item.themeId) }} {{ vm.themeName(item.theme || item.themeId) | translate }}</span>
            <span *ngIf="item.duration != null">{{ item.duration }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
            <span *ngIf="item.isRepeatable">{{ 'Toolkit.Surveys.Repeatable' | translate }}</span>
        </div>
        <div class="toolkit__libraryActions">
			<button class="toolkit__btn toolkit__btn--ghost" type="button" (click)="vm.previewItem(item)">{{ 'Toolkit.Common.Preview' | translate }}</button>
			<button class="toolkit__btn toolkit__btn--primary" type="button" (click)="vm.assignItem(item)">{{ 'Toolkit.Common.Assign' | translate }}</button>
		</div>
	</div>
</div>

<div class="toolkit__emptyPane" *ngIf="!vm.surveyItems?.length">
	<div class="toolkit__emptyTitle">{{ 'Toolkit.Placeholder.Title' | translate }}</div>
	<div class="toolkit__emptyText">{{ 'Toolkit.Surveys.Empty' | translate }}</div>
</div>
